module.exports = __webpack_public_path__ + "media/tayaya_portorico_residence.2481561f.mp4";